import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import { useTranslation } from "react-i18next";
import { WorkspaceDialog } from "./WorkspaceDialog";

interface ProductWorkspaceButtonProps {
  onCreationStateChange?: (isCreating: boolean) => void;
}

export const WorkspaceButton = ({ onCreationStateChange }: ProductWorkspaceButtonProps = {}) => {
  const { t } = useTranslation();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOpenChange = (open: boolean) => {
    setIsDialogOpen(open);
    // Notificar Navbar sobre mudança de estado
    onCreationStateChange?.(open);
  };

  const handleProductSaved = () => {
    // O WorkspaceDialog já chama reloadUserProducts internamente
    // Aqui apenas garantimos que o dialog será fechado
    setIsDialogOpen(false);
    onCreationStateChange?.(false);
  };

  return (
    <>
      <Button
        variant="default"
        size="default"
        onClick={() => handleOpenChange(true)}
        className="flex items-center gap-2"
        data-tour="create-workspace-button"
      >
        <Plus className="h-4 w-4" />
        <span>{t("common.workspaces.addWorkspace")}</span>
      </Button>

      <WorkspaceDialog
        open={isDialogOpen}
        onOpenChange={handleOpenChange}
        onWorkspaceSaved={handleProductSaved}
      />
    </>
  );
};
